export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=404e83476832857b588e807865a502b566c0131b13&name=revalidateCommunity!'